import GaugeComponent from 'react-gauge-component'

const GaugeChart = ({ score, label }) => {
  return (
    <div>
      <GaugeComponent
        style={{ maxWidth: 400, margin: '0 auto' }}
        type='radial'
        value={score}
        minValue={0}
        maxValue={10}
        marginInPercent={{ top: 0.1, bottom: 0.0, left: 0.07, right: 0.07 }}
        pointer={{ length: 0.9, width: 4, color: '#000', type: 'needle' }}
        labels={{
          valueLabel: {
            formatTextValue: (value) => value,
            style: { textShadow: 'none', fill: '#000' },
          },
        }}
        arc={{
          width: 0.35,
          padding: 0,
          cornerRadius: 0,
          gradient: true,
          colorArray: ['#7FD67A', '#ffeb3b', '#F27C6A'],
          emptyColor: '#e6e6e6',
          subArcs: [{ limit: 3.33 }, { limit: 6.66 }, { limit: 10 }],
        }}
      />
      <p className='text-center text-secondary mx-auto m-0 px-2' style={{ fontSize: 12 }}>
        {label}
      </p>
    </div>
  )
}

export default GaugeChart
